module.exports = __webpack_public_path__ + "static/media/glyph-logo_May2016.8f796e54.png";